<template>
	<div class="form-radios">
		<fieldset class="form-radios__fieldset">
			<legend
				class="form-radios__fieldset-legend"
				v-if="legend"
			>
					<span
						class="form-radios__fieldset-legend-text"
						v-html="legend"
					/>
					<span
						class="form-radios__fieldset-legend-option"
						v-if="legendOption"
						v-html="legendOption"
					/>
			</legend>

			<div
				v-for="(option, index) in options"
				:key="option.value"
				class="form-radio"
				:class="{
					'form-radio--block': vertical,
					'form-radio--error': error,
				}"
			>
				<input
					class="form-radio__field"
					type="radio"
					:id="`${uniqueId}-${index}-${option.value}`"
					:name="name"
					:required="required"
					:value="option.value"
					@change="onChange"
					:checked="option.value === value"
					:disabled="disabled"
				>
				<label
					class="form-radio__label"
					:for="`${uniqueId}-${index}-${option.value}`"
				>
					<span class="form-radio__label-box"/>
					<span class="form-radio__label-text">
						{{ option.label }}
						<slot></slot>
					</span>
				</label>
			</div>
			<span
				class="form-radio__hint | form-input-hint"
				v-if="hint"
				v-html="hint"
			/>
			<span
				class="form-radio__error | form-input-error"
				v-if="error && errorMessage"
				v-html="errorMessage"
			/>
			<span
				class="form-radio__success | form-input-success"
				v-if="successMessage"
				v-html="successMessage"
			/>
		</fieldset>
	</div>
</template>

<script>
export default {
	props: {
		name: String,
		legend: String,
		legendOption: String,
		required: Boolean,
		value: Number | String,
		options: Array,
		vertical: Boolean,
		disabled: Boolean,
		hint: String,
		error: Boolean,
		errorMessage: String,
		success: Boolean,
		successMessage: String,
	},
	data() {
		return {
			uniqueId: `${this.name}-${(Date.now().toString(36) + Math.random().toString(36).substr(2, 5))}`,
		}
	},
	methods: {
		onChange(e) {
			this.$emit('input', e.target.value);
		}
	}
}
</script>

<style>

</style>
